<script setup lang="ts">
const props = withDefaults(
  defineProps<{
    title?: string;
    form?: string;
    heights?: { base: string; small: string; medium: string; large: string };
  }>(),
  {
    title: undefined,
    form: undefined,
    heights: () => ({
      base: "1450px",
      small: "1280px",
      medium: "1190px",
      large: "1125px",
    }),
  },
);

const article = inject(keys.currentArticle, null);

const resolvedForm = computed(() => {
  let form = props.form;
  if (!form && article?.contentType === "article") {
    form = article?.hubspotForm;
  }

  return form && useExtractLink(form);
});
</script>

<template>
  <section class="hubspot-form">
    <h2 v-if="title" v-text="title" />
    <iframe :src="resolvedForm" title="Hubspot-skjema" />
  </section>
</template>

<style scoped>
.hubspot-form {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  gap: 1rem;
  margin: 1rem auto;

  iframe {
    flex-grow: 1;
    border: none;
  }
}

.hubspot-form,
iframe {
  height: v-bind("heights.base");

  @media screen and (min-width: 350px) {
    height: v-bind("heights.small");
  }

  @media screen and (min-width: 500px) {
    height: v-bind("heights.medium");
  }

  @media screen and (min-width: 600px) {
    height: v-bind("heights.large");
  }
}
</style>
